import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Main = styled.div``;

const ModalBlock = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 0.5px solid var(--border-primary);
  padding: 12px 16px;
  gap: 20px;
`;

const ModalHeader = styled.div`
  display: flex;
  gap: 10px;
`;

const ModalTitle = styled.h2`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: 0;
`;
const Icon = styled.div`
  cursor: pointer;
  display: flex;
  gap: 15px;
  :hover .fillColor {
    background-color: var(--neutral-secondary);
    border-radius: 4px;
  }
  .fillColor {
    stroke: var(--text-primary);
  }
`;
const ModalContent = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
`;

const ModalForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ModalInput = styled.input`
  padding: 8px 12px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  ${Typography.body_lg}
  color: var(--text-primary);
  outline: none;
  :focus {
    border: 0.5px solid var(--brand-primary);
  }
  ::placeholder {
    color: var(--text-placeholder);
  }
  ${mobile_xl(css`
    border-radius: 6px;
  `)}
`;
const Label = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const ModalButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const InputDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 3px 7px;
  border: 0.5px solid var(--border-primary);
  background: none;
  border-radius: 6px;
  min-height: 28px;
  cursor: pointer;
  min-width: 352px;
  max-width: 352px;
  justify-content: space-between;

  &:hover {
    border-color: var(--primary);
  }
  .angleDown-icon {
    transition: transform 0.2s ease;
    position: absolute;
    right: 8px;
    /* transform: translateY(-50%); */
    &.rotate {
      transform: rotate(180deg);
    }
    path {
      stroke: var(--text-primary);
      width: 18px;
      height: 18px;
    }
  }
`;

const InputData = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  width: 100%;
`;

const SelectedUser = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  border-radius: 4px;
  border: 0.5px solid var(--border-primary);
  background: var(--neutral-secondary);
  ${Typography.body_md}
  color: var(--text-primary);

  svg {
    stroke: var(--text-secondary);
  }
`;

const Input = styled.input`
  border: none;
  outline: none;
  background: transparent;
  flex: 1;
  :placeholder {
    color: var(--text-secondary);
  }
`;
const DropDiv = styled.div`
  max-height: 186px;
  overflow-y: auto;
  &:focus {
    outline: none;
  }
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--text-placeholder);
    border-radius: 4px;
  }
`;
export {
  Main,
  ModalBlock,
  ModalHeader,
  ModalTitle,
  Icon,
  ModalContent,
  ModalForm,
  ModalInput,
  Label,
  ModalButton,
  InputDiv,
  InputData,
  SelectedUser,
  Input,
  DropDiv
};
